
export const purchasesNav = [
    {url: '/purchases', label: 'Purchases', key: 'purchases.index', permissions: []},
]